module.exports = __webpack_public_path__ + "static/media/large_event_attendees.5a2b44ce.png";